import React, { useState, useRef, useEffect } from 'react';
import HelpButton from 'app/components/common/HelpButton.jsx';

const CalendarToolbar = (props) => {
    const [ showFilter, setShowFilter ] = useState(false);
    const filterMenu = useRef(null);

    const filterAction = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let type = e.target.dataset.filter;

        props.filterEvents(type);
        setShowFilter(false);

    };

    const interactionCheck = (e) => {
        if (showFilter) {
            if (filterMenu.current && filterMenu.current.contains(e.target)) {
                return;
            }
            setShowFilter(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mouseup', interactionCheck);
        document.addEventListener('touchend', interactionCheck);

        return () => {
            document.removeEventListener('mouseup', interactionCheck);
            document.removeEventListener('touchend', interactionCheck);
        }
    }, [showFilter]);

    let filterElement = null;
    if (showFilter) {
        let activeFilter = (
            <i className="icon ion-checkmark"/>
        );

        filterElement = (
            <div className="calendar-filter" ref={filterMenu}>
                <ul className="filter-options" onClick={filterAction}>
                    <li data-filter="scheduled">
                        <span className="active-filter">{props.currentFilter === 'scheduled' ? activeFilter: null}</span> Scheduled
                    </li>
                    <li data-filter="queue">
                        <span className="active-filter">{props.currentFilter === 'queue' ? activeFilter: null}</span> Queued
                    </li>
                    <li data-filter="direct">
                        <span className="active-filter">{props.currentFilter === 'direct' ? activeFilter: null}</span> Direct
                    </li>
                    <li data-filter="everqueue">
                        <span className="active-filter">{props.currentFilter === 'everqueue' ? activeFilter: null}</span> Everqueued
                    </li>
                    <li data-filter="">
                        <span className="active-filter">{props.currentFilter === '' ? activeFilter: null}</span> Show All
                    </li>
                </ul>
            </div>
        );
    }

    let dateLabel = '';
    if (props.currentView === 'month') {
        dateLabel = props.displayDate.format("MMMM YYYY");
    } else if (props.currentView === 'week') {
        let startOfWeek = null,
            endOfWeek = null;

        startOfWeek = new moment(props.displayDate).tz(props.timezone).subtract(props.displayDate.day(), 'days');
        endOfWeek = new moment(startOfWeek).tz(props.timezone).add(6, 'days');

        if (startOfWeek.month() !== endOfWeek.month()) {
            dateLabel = `${startOfWeek.format('MMM DD')} - ${endOfWeek.format('MMM DD')}`;
        } else {
            dateLabel = `${startOfWeek.format('MMMM DD')} - ${endOfWeek.format('DD')}`;
        }
    }

    let ariaLabelPrevious = (props.currentView === 'month') ? 'Previous Month' : 'Previous Week',
        ariaLabelNext = (props.currentView === 'month') ? 'Next Month' : 'Next Week';

    return (
        <div className="dlvr-calendar-toolbar">
            <div className="date-controls">
                <div className="date-chooser">
                    <div className="prev-button nav-button" arial-label={ariaLabelPrevious} onClick={() => {
                        props.navigate('PREV');
                    }}>
                        <i className="fa fa-chevron-circle-left"/>
                    </div>
                    <div className="date-label">{dateLabel}</div>
                    <div className="next-button nav-button" arial-label={ariaLabelNext} onClick={() => {
                        props.navigate('NEXT');
                    }}>
                        <i className="fa fa-chevron-circle-right"/>
                    </div>
                </div>
            </div>
            <div className="calendar-controls">
                <div className="filter-button" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    let nextFilterState = showFilter ? false : true;
                    setShowFilter(nextFilterState);
                }}>
                    <i className="icon ion-android-funnel"/>
                    {filterElement}
                </div>
                <div className="timezone-indicator">
                    UTC {new moment().tz(props.user.detail.timezone).format("Z")} <span className="help-wrapper"><HelpButton which="timezone"/></span>
                </div>
            </div>
        </div>
    );
}

export default CalendarToolbar;
